import request from '@/utils/request'

// 列出文章
export function listArticles(data) {
  return request({
    url: '/services/articles/listArticles',
    method: 'post',
    data,
  })
}

// 热门文章top10
export async function hotArticlesTop10() {
  const res = await request({
    url: '/services/articles/hotArticlesTop10',
    method: 'get',
  })
  const { data, success, msg } = res
  if (!success) return []
  data.forEach((n) => {
    const timeArr = n.publishTime.split('-')
    n.time = `${timeArr[1]}.${timeArr[2]} `
  })
  return data
}

// 根据文章id获取前后文章信息
export function getArticleAdjacentInfo(data) {
  return request({
    url: '/services/articles/getArticleAdjacentInfo',
    method: 'post',
    data,
  })
}

// 获取文章详情
export function getArticleDetail(id) {
  return request({
    url: `/services/articles/getArticleDetail/${id}`,
    method: 'get',
  })
}
